import React, {useState} from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import history from "../../../../libs/history";
import {Link} from "react-router-dom";
import DateRoom from "../../../components/messenger/DateRoom";
// import DraftContentExcerpt from "../../../components/editor/DraftContentExcerpt";
import Dropdown from "../../../components/Dropdown";
import Icon from "../../../components/Icon";
import {Button} from "../../../components/Button";
import Avatar from '../../../components/Avatar';
import createLink from "../../../../libs/createLink";
import {Can} from "../../../../ability-context";
import Alert from "../../../components/Alert";
import Modal from "../../../components/Modal";

const RoomItem = ({
                      room,
                      selectedRoomId,
                      handleRoomMarkRead,
                      handleRoomLock,
                      handleOpenRoom,
                      handleRoomArchived,
                      handleRemoveRoom
                  }) => {

    if(selectedRoomId === room._id && !room.isReadByCurrentUser){
        handleRoomMarkRead(room._id, true);
    }
    let [toggleRemoveRoom, setToggleRemoveRoom] = useState(false);

    return (
        <li key={room._id}
            className={classNames("messenger-room row", {
                active: selectedRoomId === room._id,
                unread: !room.isReadByCurrentUser
            })}>
            <div className={classNames("status-dot my-auto", {
                online: room.hasUserOnline,
                offline: !room.hasUserOnline,
            })}/>
            <div className="wrapper-room" onClick={() => room.isGroup ? handleOpenRoom(room._id) : null}>
                {
                    room.isGroup
                        ? <Avatar avatar={room.users.map(user => _.get(user, "profile.avatar"))}/>
                        : <Link to={createLink('userProfile', _.get(room.participantsWithoutCurrent, '[0]'))}><Avatar avatar={_.get(room.participantsWithoutCurrent, "[0].profile.avatar")}
                                                    gender={_.get(room.participantsWithoutCurrent, "[0].profile.gender")}/></Link>
                }
                <div className="content" onClick={() => handleOpenRoom(room._id)}>
                    <div className="message-info">
                        <div className="username-list">
                            {room.isGroup && room.groupName
                                ? room.groupName
                                : room.participantsWithoutCurrent.map((user, index) => <span key={index}
                                                                                             className="username">{user.username}</span>)
                            }
                            {room.isLocked && <span className="room-locked"> Vérrouillée</span>}
                        </div>
                        <div className="updated-at">
                            <DateRoom lastMessageCreatedAt={room.lastMessageCreatedAt}/>
                        </div>
                    </div>
                    <div className="message-excerpt">
                        {room.lastMessageContent && !room.lastMessageContent.isDeleted && _.get(room, 'lastMessageContent.kind') !== "involve" &&
                        <span className="last-message">
                                {(room.lastMessageContent.kind === "media" || room.lastMessageContent.kind === "gallery" || room.lastMessageContent.kind === "video")
                                    ? `${room.lastMessageOwner && room.lastMessageOwner.username} a envoyé un media`
                                    : `${room.lastMessageContent.text.substring(0, 50)}${room.lastMessageContent.text.length > 50 ? "..." : ""}`
                                }
                            </span>
                        }
                        {room.lastMessageContent && room.lastMessageContent.isDeleted ?
                        <span className="last-message">
                            Message supprimé
                            </span> : null
                        }
                        {_.get(room, 'lastMessageContent.kind') === "involve" &&
                        <span className="last-message">
                                {_.get(room, 'lastMessageContent.involve') === "join"
                                    ? `${room.lastMessageOwner && room.lastMessageOwner.username} a rejoind la conversation`
                                    : `${room.lastMessageOwner && room.lastMessageOwner.username} a quitté la conversation`
                                }
                            </span>
                        }
                    </div>
                </div>
            </div>
            <Can action="update" subject={"Room"}>
                <Dropdown activableComponent={(
                    <Icon type="cog"/>
                )}>
                    <ul className="dropdown-menu">
                        <li className="menu-item"
                            onClick={() => handleRoomMarkRead(room._id, !room.isReadByCurrentUser)}>
                            <span>
                                <Icon
                                    type={"envelope-o"}/>{room.isReadByCurrentUser ? "Marquer comme non lue" : "Marquer comme lue"}
                            </span>
                        </li>
                        <li className="menu-item"
                            onClick={() => handleRoomArchived(room._id, !room.currentUserIsArchived)}>
                            <span>
                                <Icon
                                    type={"archive"}/>{room.currentUserIsArchived ? "Restaurer" : "Archiver"}
                            </span>
                        </li>
                        {!room.isGroup ? (
                            <li className="menu-item"
                                onClick={() => setToggleRemoveRoom(true)}>
                                <Icon type={"trash"}/>
                                Effacer la conversation
                            </li>
                            ) : null
                        }
                        {/*<li className="menu-item"><Icon*/}
                        {/*    type={"report"}/> <Report*/}
                        {/*    endMessage="(spam/abus)"/>*/}
                        {/*</li>*/}
                        {(!room.isGroup && (!room.isLocked || room.currentUserIsLocker)) && (
                            <li className="menu-item"
                                onClick={() => handleRoomLock(room._id, !room.isLocked)}>
                                <Icon type={"ban"}/>
                                {room.isLocked ? "Débloquer" : "Bloquer "} la conversation
                            </li>)}
                    </ul>
                </Dropdown>
            </Can>
            <Modal toggle={toggleRemoveRoom}
                   handleClose={() => setToggleRemoveRoom(false)}>
                <Alert
                    text={"Tous vos messages dans cette conversation seront supprimés. Souhaitez-vous continuer ?"}
                    handleClose={() => setToggleRemoveRoom(false)}
                    handleDelete={() => handleRemoveRoom(room._id)}/>
            </Modal>
        </li>
    )
}

const Rooms = ({
                   rooms = [],
                   roomsTotal = 0,
                   noContentMessage = "Aucune discussion en cours",
                   selectedRoomId = null,
                   more = false,
                   handleShowMore = () => {
                   },
                   handleOpenRoom = () => {
                   },
                   handleRoomMarkRead = () => {
                   },
                   handleRoomLock = () => {
                   },
                   handleRoomArchived = ()=>{
                   },
                   handleRemoveRoom = ()=>{

                   }
               }) => {

    if(selectedRoomId && selectedRoomId !== "new" && Array.isArray(rooms)){
        let isRoom = rooms.find(room => room._id.toString() === selectedRoomId.toString());
        if(!isRoom){
            history.push(createLink("messenger"))
        }
    }

    return (
        <div className="rooms-list">
            {rooms.length === 0 && <div className={"no-content no-border"}>{noContentMessage}</div>}
            {rooms.map((item) => <RoomItem
                key={item._id}
                room={item}
                selectedRoomId={selectedRoomId}
                handleOpenRoom={handleOpenRoom}
                handleRoomMarkRead={handleRoomMarkRead}
                handleRoomLock={handleRoomLock}
                handleRoomArchived={handleRoomArchived}
                handleRemoveRoom={handleRemoveRoom}
            />)}
            {(more && rooms.length > 1) && (
                <div className="messenger-room p-16">
                    <Button btnStyle={"primary-reverse"}
                            size={"small"}
                            className={"full"}
                            onClick={handleShowMore}
                            content={"Afficher vos anciennes conversations"}/>
                </div>
            )}
        </div>
    )
}

export default Rooms;